import VerifyResetPasswordPage from "./VerifyResetPasswordPage";

export default VerifyResetPasswordPage;
